import React, { useContext, useState } from "react";
import { Col, Form } from "react-bootstrap";
import SleeveChudiDisplay from "./sleevedisplay";
import { ChudidharContext } from "../../../context/chudidharContext";
import { useTranslation } from 'react-i18next';

const ChudiSleeveList=()=>{
    const {chudiSleeveData}=useContext(ChudidharContext);
    const [filterSleeve,setFilterSleeve]=useState("");
    const { t, i18n } = useTranslation();

    const FilterData=chudiSleeveData.filter(each=>(
        each.name.toLowerCase().includes(filterSleeve.toLowerCase())
      ))


    return(
        <>
        <div className="d-flex mt-2">
           <Col className="">
            <Form.Control type="text" 
            onChange={(e)=>setFilterSleeve(e.target.value)}
            placeholder="Search By Items..." />
            </Col>
            <Col className="mx-2 mt-2" lg={5} sm={4} md={4}>
            <p className="text-dark ">{t('main.search_total')} {FilterData.length}</p>
            </Col>
        </div>
        <div className="leftside_items_sleeve">
           {FilterData?.map(each=>(
                  <SleeveChudiDisplay key={each.id}
                  icon={each.icon}
                  name={each.name}
                  data={each}>
                  </SleeveChudiDisplay>
                 ))}
        </div>
        </>
    )
}
export default ChudiSleeveList